import { INSIGHTS } from "constants/action-types";
import { FluxStandardAction as Action } from "flux-standard-action";
import { Dispatch } from "react-redux";
import { ThunkAction } from "redux-thunk";
import type { IStore } from "reducers";

export type FetchProductStyleInsightsAction = Action<{ viewAsCompanyId?: string }, {}>;

export const fetchProductStyleInsights = (
    viewAsCompanyId: string = null,
    force: boolean = false,
): ThunkAction<void, IStore, FetchProductStyleInsightsAction> => {
    return (dispatch: Dispatch<IStore>, getState: () => IStore) => {
        const { productStyles } = getState().insights;
        // If we already have product style insights, don't fetch them again
        if (
            !force &&
            !viewAsCompanyId &&
            (productStyles?.immediate?.length > 0 || productStyles?.prebook?.length > 0)
        ) {
            return;
        } else {
            dispatch({
                type: INSIGHTS.FETCH_PRODUCT_STYLE_INSIGHTS.START,
                payload: {
                    viewAsCompanyId,
                },
                meta: {},
            });
        }
    };
};
